import { useTranslation } from "react-i18next";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import React from "react";
import { PalletsPageContent } from "../../Components/Features/Inventory/Pallets/PalletsPageContent";

export function PalletsPage() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <PageLayout title={t("pallets")}>
        <div className="h-fit max-w-1/2  bg-white rounded-xl shadow-accent-foreground shadow-2xl p-4">
          <PalletsPageContent />
        </div>
      </PageLayout>
    </AppLayout>
  );
}
